export class SpecificH {

  isPublished: boolean;
  isInterventional: boolean;
  concernsDelicatePrivacyAspects: boolean;
  includesInterviewedMinors: boolean;
  documentParentsMinors: boolean;
  isLiveQualityOrTreatmentComplianceSurvey: boolean;
  includesInterviewedFragilePatients: boolean;

}
